import React from 'react'
import {ILocationModel} from './LocationModel'
import DataTable, {TableAction, TableColumn} from '../../../../shared/components/DataTable'

type Props = {
  data: ILocationModel[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  onEdit: (location: ILocationModel) => void
  onDelete: (location: ILocationModel) => void
  loading?: boolean
}

export const LocationTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  onEdit,
  onDelete,
  loading = false,
}) => {
  const columns: TableColumn<ILocationModel>[] = [
    {key: 'province', label: 'İl', className: 'fw-semibold'},
    {key: 'district', label: 'İlçe'},
  ]

  const actions: TableAction<ILocationModel>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: onEdit,
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: onDelete,
    },
  ]

  return (
    <DataTable
      data={data}
      columns={columns}
      actions={actions}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      loading={loading}
      emptyMessage='Henüz lokasyon bulunamadı'
    />
  )
}
